import * as z from 'zod';

export const GoalscorerSchema = z.object({
  name: z.string(),
  goals: z.number(),
  position: z.string().nullable(),
  flag: z.string().nullable(),
});

const TopGoalscorersSchema = z.object({
  home: z.array(GoalscorerSchema),
  away: z.array(GoalscorerSchema),
});

export default TopGoalscorersSchema;
